const key = 'mock-client';

export const getEnvMockValue = () => {
  const defaultValue = 'true';

  const applyValue = (item: string) => {
    return item === 'true';
  };

  const temp = 'true';
  const value = applyValue(temp?.length ? temp : defaultValue);

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  return value || localStorage.getItem(key) === 'true';
};

export const getMockClientStatus = () => {
  let status = false;
  if (localStorage.getItem(key) === 'true') {
    status = true;
  }

  if (getEnvMockValue()) {
    status = true;
  }

  return status;
};

export const setMockClientStatus = (status: boolean) => {
  localStorage.setItem(key, status ? 'true' : 'false');
};
